import React, { CSSProperties, ReactNode } from 'react'
import { useSelector } from 'react-redux'
import { State } from 'shared'

interface BackgroundProps {
  children: ReactNode
}

const Background: React.FC<BackgroundProps> = ({ children }) => {
  const background = useSelector((state: State) => state.bikeConfig.background)

  const { color, image, mode } = background

  let style: CSSProperties = {
    backgroundColor: color
  }

  if (image) {
    style.backgroundImage = `url(${image})`
    style.backgroundPosition = 'center center'
    switch (mode) {
      case 'contain':
        style.backgroundSize = 'contain'
        style.backgroundRepeat = 'no-repeat'
        break

      case 'repeat':
        style.backgroundSize = 'auto'
        style.backgroundRepeat = 'repeat'
        break

      default:
        // cover
        style.backgroundSize = 'cover'
        style.backgroundRepeat = 'no-repeat'
        break
    }
  } else {
    style.backgroundImage = `radial-gradient(circle, #efefef 10%, ${color})`
  }

  return (
    <div className="velorbis-customizer-background" style={style}>
      {children}
    </div>
  )
}

export default Background
